import React, {createContext, useContext, useState} from "react";

export const LangContext = createContext({
  lang:'en',
  setLang:()=>{},

});


export const LangProvider = ({children}) => {




  const [lang, setLang] = useState('en');



 const upd = (u) => setLang(u);
  const value = {
    lang,
    setLang

  };

  return (<div>

    <LangContext.Provider value={value}>
      {children}
    </LangContext.Provider>
  </div>)

};
export const useLang = () => useContext(LangContext);
